var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.002 200.004C155.232 200.004 200.004 155.232 200.004 100.002C200.004 44.7725 155.232 0 100.002 0C44.7725 0 0 44.7725 0 100.002C0 155.232 44.7725 200.004 100.002 200.004Z",
    fill: "#F08437"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.842 84.8698C146.278 92.6173 137.26 116.322 120.828 123.563C118.096 124.767 115.018 125.935 111.735 127.059L125.177 140.399C125.177 140.399 139.491 133.869 150.028 122.306C153.013 119.032 157.411 114.429 160.41 110.031C164.257 104.394 164.612 102.231 164.612 102.231L148.842 84.8698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8097 99.4186L56.8135 130.626L34.415 136.215L21.6788 100.054C21.6788 100.054 20.3061 90.4938 29.2308 89.019C38.9107 87.4108 41.0297 100.818 41.0297 100.818L45.8097 99.4186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61 132.403L145.012 136.806C145.012 136.806 134.164 145.02 140.17 152.798C145.697 159.946 153.471 154.193 153.471 154.193L178.623 126.206L163.226 109.21C163.226 109.21 159.383 113.799 155.23 118.81C153.87 120.444 150.028 124.607 147.234 127.21C143.671 130.506 140.517 132.612 140.61 132.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9033 44H148.411V81.1516C148.411 81.1516 139.375 113.621 119.624 122.323C99.8734 131.026 61.7223 138.054 61.7223 138.054L43.2998 86.5624L77.2795 76.8735C77.5683 77.8331 74.2365 68.7707 73.9699 61.0898C73.8056 56.3676 73.9033 44 73.9033 44Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.021,
    height: 112.382,
    fill: "white",
    transform: "translate(21.6028 44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.021,
    height: 112.382,
    fill: "white",
    transform: "translate(21.6028 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApp);
export default __webpack_public_path__ + "static/media/logo-app.3d3102edd80254a7802015919f2d7a82.svg";
export { ForwardRef as ReactComponent };